import { lazy } from 'react';
import { Location } from '@core/Router/locations';

const UserListPageContainer = lazy(() =>
    import(/* webpackChunkName: "user" */ '@user/ui/UserListPage').then(m => ({ default: m.UserListPage })),
);
const UserPage = lazy(() =>
    import(/* webpackChunkName: "user" */ '@user/ui/UserPage').then(m => ({ default: m.UserPage })),
);
export const userLocations: Location[] = [
    {
        url: '/user',
        Component: UserListPageContainer,
    },
    {
        url: '/user/:userId',
        Component: UserPage,
    },
];
